<template>
  <span class="type-heading-xs">
    <slot></slot>
  </span>
</template>
